<template>
  <CModal :show="show" :closeOnBackdrop="false" :centered="true" size="lg">
    <template #header>
      <h5 class="modal-title">{{ title }}</h5>
    </template>
    <div v-if="!loading">
      <form @submit.prevent="onSubmit">
        <div class="form-group">
          <label>{{ $t("role.planning.closing.name") }}</label>
          <CInput v-model="form.name" type="text" />
        </div>

        <div class="form-group">
          <label>{{ $t("role.planning.closing.from") }}</label>
          <CInput v-model="form.start" type="date" />
        </div>

        <div class="form-group">
          <label>{{ $t("role.planning.closing.until") }}</label>
          <CInput v-model="form.end" type="date" />
        </div>
      </form>

      <CAlert v-if="validationError" color="danger" :show.sync="showAlert">
        {{ validationError }}
      </CAlert>
    </div>
    <div
      v-else
      class="d-flex justify-content-center align-items-center"
      style="height: 200px"
    >
      <CSpinner color="primary" />
    </div>

    <template #footer>
      <CButton color="primary" variant="outline" @click.prevent="closeModal">
        {{ $t("common.editor.cancel") }}
      </CButton>
      <vue-ladda
        :loading="loading"
        data-style="zoom-in"
        button-class="btn btn-primary px-4"
        @click.prevent="onSubmit"
      >
        {{ $t("common.editor.confirm") }}
      </vue-ladda>
    </template>
  </CModal>
</template>

<script>
import { apiPatch, apiPost } from "../../../helpers/apiHelper";

export default {
  name: "ClosingModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    editId: {
      type: [Number, String],
      default: null,
    },
    values: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      loading: false,
      validationError: null,
      showAlert: false,
      form: {
        name: "",
        start: "",
        end: "",
      },
    };
  },

  watch: {
    show: {
      handler(isShown) {
        if (isShown) {
          if (this.values && Object.keys(this.values).length > 0) {
            this.populateForm(this.values);
          } else {
            this.resetForm();
          }
        }
      },
      immediate: false,
    },
    values: {
      handler(newValues) {
        if (newValues && Object.keys(newValues).length > 0) {
          this.populateForm(newValues);
        }
      },
      immediate: true,
    },
  },

  methods: {
    populateForm(data) {
      this.form.name = data.name || "";
      this.form.start = data.start || "";
      this.form.end = data.end || "";
      this.loading = false;
    },

    async onSubmit() {
      this.validationError = null;
      this.showAlert = false;

      // Validation
      if (!this.form.name) {
        this.validationError = this.$t("role.planning.closing.validation.name");
        this.showAlert = true;
        return;
      }

      if (!this.form.start) {
        this.validationError = this.$t(
          "role.planning.closing.validation.start"
        );
        this.showAlert = true;
        return;
      }

      if (!this.form.end) {
        this.validationError = this.$t("role.planning.closing.validation.end");
        this.showAlert = true;
        return;
      }

      // Validate end date is same or after start date
      const startDate = new Date(this.form.start);
      const endDate = new Date(this.form.end);
      if (endDate < startDate) {
        this.validationError = this.$t(
          "role.planning.closing.validation.end_before_start"
        );
        this.showAlert = true;
        return;
      }

      const requestParams = this.form;

      // check user permissions before submitting
      const perm = this.$store.state.connections.current.permissions.role_lg;
      if (perm !== 2) {
        this.validationError = this.$t(
          "models.market_plan.addForm.validation.permissions"
        );
        this.showAlert = true;
        return;
      }

      let response;
      if (this.editMode && this.editId) {
        response = await apiPatch(
          "role_planningclose",
          this.editId,
          requestParams,
          [this.$store.state.role.id]
        );
      } else {
        response = await apiPost("role_planningclose", requestParams, [
          this.$store.state.role.id,
        ]);
      }

      if (response) {
        this.$emit("submitted");
        this.closeModal();
      }
    },

    closeModal() {
      this.$emit("update:show", false);
      this.validationError = null;
      this.showAlert = false;
    },

    resetForm() {
      this.form = {
        name: "",
        start: "",
        end: "",
      };
      this.validationError = null;
      this.showAlert = false;
    },
  },
};
</script>
